/* v8 ignore next */
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/* v8 ignore next 2 */
const LoadingSpinnerComponent = ({ className }: { readonly className?: string }) => (
	<FontAwesomeIcon className={className} data-testid="loading-spin" icon={faSpinner} size="6x" spin />
)

export default LoadingSpinnerComponent
